import React, { useEffect, useMemo, useState } from "react";
import {
  Row,
  Col,
   Container,
} from "react-bootstrap";
import { constants } from "../constants";
import DocumentViewer from "../util/DocumentViewer";
import Heading from "../components/Heading";
import { useLocation } from "react-router-dom";
import axiosInstance from "../api/axiosConfig";
import AddColumnTable from "../components/AddColumnTable";
import Loading from "../components/Loading";
import AccordionPanel from "../components/AccordionPanel";
import VerifyRecordTable from "../components/VerifyRecordTable";
const DataMapping = () => {
  const [fileURL, setFileURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [failData, setFailData] = useState([]);
  const [error, setError] = useState(null);
  const [fileError, setFileError] = useState(null);

  const [synonyms, setSynonyms] = useState([]);
  const location = useLocation();
  const fileName = useMemo(() => location.state?.fileName || "", [location.state]);
  const [newColumns, setNewColumns] = useState({});
  const [success, setSuccess] = useState(false);
  const [verifyStatus, setVerifyStatus] = useState({});
  const [saveLoading, setSaveLoading]   = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [fileType, setFileType]  = useState(null);
  const [reRunLoading, setReRunLoading]   = useState(false);
  const [isreRunDisabled, setIsRerunDisabled] = useState(false);
  const [visible, setVisible] = useState(true);

  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("/get_col_names");
        setSynonyms(response.data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const loadFile = async () => {
      try {
        const file = await axiosInstance.post("/s3_file_display", {
          action: "open_file",
          file_key: fileName,
        });
        if(file.data?.type ==="excel"){
          setFileType("excel");
          setFileURL(file.data.data);
        } else{
          setFileType("pdf");
          setFileURL(`data:application/pdf;base64,${file.data}`);
        }
      } catch (error) {
        setFileError(error.response.data);
        setLoading(false);
       
      }
    };
    if (fileName) {
      loadFile();
    }
  }, [fileName]);



  useEffect(() => {
    const getFailureRecords = async () => {
      try {
        const response = await axiosInstance.post("/get_failure_records", {
          action: "get_failures",
          file_name: fileName,
        });
        setFailData(response.data.failures);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    if (fileName) {
      getFailureRecords();
    }
  }, [fileName]);


  
  const handleSave = async () => {
    setSaveLoading(true);
    setSuccess("");
    setVisible(false)
    try {
      let isValid = true;
      Object.entries(newColumns).forEach(([key, values]) => {
          values.forEach((value, index) => {
              if (value.trim() === '') {
                  isValid = false;
                  alert(`Please fill in all fields for ${key}`);
              }
          });
      });

      if (isValid) {
      const response = await axiosInstance.put("/add_synonym", newColumns);
      setSynonyms(response.data.data);
      setSuccess(response.data.message);
      setNewColumns("");
      setVisible(true)
      }
    } catch (error) {
        // setError(error);
    } finally {
      setSaveLoading(false)
      setIsSaveDisabled(true)
    }
  };

  const handleRerun = async () => {
    setReRunLoading(true);
    setIsRerunDisabled(true)
    setSuccess("");
    setVisible(false)
    try {
      const response = await axiosInstance.post("/rerun_file", {
        file_name: fileName,
      });
      // setSynonyms(response.data.data);
      setSuccess(response.data.message);
      setNewColumns("");
      setVisible(true)
    } catch (error) {
      // setMessage('Error saving data.');
    } finally {
      setReRunLoading(false);
      setIsRerunDisabled(false)  
      }
  };


  // handle verify

  const handleVerify = async (item,index) => {
    try {
        setVerifyStatus((prevStatus) => ({
          ...prevStatus,
          [index]: "Verifying",
        }));       
      const response = await axiosInstance.post("/verify_record", {
        columns: item,
      });

      if(response?.status===200){
        setVerifyStatus((prevStatus) => ({
          ...prevStatus,
          [index]: "Verified",
        }));
      }
    } catch (error) {
    } 
  };


  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Heading title={constants.MAPPING} />
          <Container className="main">
           {/* <Row>
            <Col className="d-flex justify-content-center align-items-center full-height">
              {error && (
              <Error message={error.message} />
              )}
            {success && (
              <Success message={error.message} />
            )}
            </Col>
          </Row> */}
          {/* <DocxViewer /> */}
            {/* <DisplayWordDocument/> */}
            <Row >
              <Col md={12} className="mt-4">
                <AccordionPanel item={ { title:"Document Viewer",open:true, content: <DocumentViewer 
                docUrl={fileURL}  fileType={fileType} fileName={fileName} fileError={fileError}/> }}/>
              </Col>

              <Col md={12}>
                <AccordionPanel item={ { title:"Verify", content: <VerifyRecordTable failData={failData}  handleVerify={handleVerify} verifyStatus={verifyStatus}/> }}/>
              </Col>
              
              <Col md={12} className="mb-4">
                <AccordionPanel item={ { title:constants.ADD_SYNONYMS, content: <AddColumnTable
                  initialData={synonyms}
                  newColumns={newColumns}
                  setNewColumns={setNewColumns}
                  setSynonyms={setSynonyms}
                  handleRerun={handleRerun}
                  handleSave={handleSave}
                  saveLoading={saveLoading} 
                  setSaveLoading={setSaveLoading}
                  isSaveDisabled={isSaveDisabled}
                   setIsSaveDisabled={setIsSaveDisabled}
                   success={success}
                   error={error}
                  setVisible={setVisible}
                  visible={visible}
                  reRunLoading={reRunLoading}
                  isreRunDisabled={isreRunDisabled}
                /> }}/>
              
              </Col>
            </Row>

            
      </Container>
    </>
  );
};

export default DataMapping;
